<template>
  <tbody>
  <tr v-on:click="onSelectionChanged" v-bind:class="{selected: selected}">
    <td class="compact half-padding">
      <a-checkbox
          ref="checkbox"
          :checked="selected"
          @change="onSelectionChanged"
          v-on:click.stop
      ></a-checkbox>
    </td>
    <td class="compact">
      {{ afdMessage.message_id }}
    </td>
    <td class="compact">
      {{ afdMessage.contract_number }}
    </td>
    <td class="compact">
      {{ afdMessage.agency_name }}
    </td>
    <td class="compact">
      {{ afdMessage.branch_name }}
    </td>
    <td>
      <AFDMessageDescriptionComponent :afd-message="afdMessage" :key="afdMessage.id"/>
    </td>
    <td class="compact">
      {{ date | moment("D/MM/YYYY HH:MM:SS") }}
    </td>
    <td class="compact text-right">
      <!--            <a-button :loading="unmatchLoading" v-on:click.stop="onUnmatchClick" type="danger">-->
      <!--                <link-variant-off-icon></link-variant-off-icon>-->
      <!--                Ontkoppel-->
      <!--            </a-button>-->
      <!--            <a-button v-on:click.stop="onMatchClick">-->
      <!--                <link-variant-icon></link-variant-icon>-->
      <!--                Koppelen-->
      <!--            </a-button>-->
      <a-tooltip placement="left">
        <template slot="title">
          <span>Verwerken</span>
        </template>
        <a-button v-on:click.stop="onProcessClick" :loading="processLoading" type="primary">
          <check-icon/>
        </a-button>
      </a-tooltip>
      <a-tooltip placement="left">
        <template slot="title">
          <span>Gegroepeerde berichten</span>
        </template>
        <a-button v-on:click.stop="onShowGroupedClick" :disabled="afdMessage.grouped_count === 1"
                  class="collapse-button" v-bind:class="{ open: groupedOpened}"
                  :loading="processLoading">
          {{ afdMessage.grouped_count }}
          <chevron-down-icon class="icon"/>
        </a-button>
      </a-tooltip>
    </td>
  </tr>
  <tr v-if="groupedOpened" v-for="subAFDMessage in subAFDMessages" v-bind:class="{selected: selected}">
    <td></td>
    <td class="compact">
      {{ afdMessage.message_id }}
    </td>
    <td class="compact">
      {{ afdMessage.contract_number }}
    </td>
    <td class="compact">
      {{ afdMessage.agency_name }}
    </td>
    <td class="compact">
      {{ afdMessage.branch_name }}
    </td>
    <td>
      <AFDMessageDescriptionComponent :afd-message="afdMessage"/>
    </td>
    <td class="compact">
      {{ date | moment("D/MM/YYYY HH:MM:SS") }}
    </td>
    <td>
    </td>
  </tr>
  </tbody>
</template>

<script>
import {mapGetters} from "vuex";
import store from "../store";
import afdMessageApi from "~/api/afd_message";
import BadgeComponent from "~/modules/customer/components/BadgeComponent";
import AFDMessageDescriptionComponent from "./AFDMessageDescriptionComponent";

export default {
  name: "UnprocessedGroupedAFDMessageRowComponent",
  props: {
    afdMessage: {
      type: Object,
      required: true
    }
  },
  components: {
    AFDMessageDescriptionComponent,
    BadgeComponent
  },
  data() {
    return {
      groupedOpened: false,
      editing: false,
      updateNameLoading: false,
      processLoading: false,
      unmatchLoading: false,
      subAFDMessages: [],
    }
  },
  computed: {
    ...mapGetters({
      name: '$_email/name',
    }),
    selected() {
      return store.state.selectedAFDMessages.findIndex(x => x.id === this.afdMessage.id) >= 0;
    },
    date() {
      return new Date(this.afdMessage.datetime);
    }
  },
  created() {
    const STORE_KEY = '$_email';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  },
  mounted() {
    if (this.afdMessage.grouped_count > 1) {
      afdMessageApi.getUnprocessedByGroupedAfdMessage(this.afdMessage.id).then(response => {
        this.subAFDMessages = response.data;
      });
    }
  },
  methods: {
    onUnmatchClick() {
      this.unmatchLoading = true;
      emailApi.unmatchEmail(this.email.id).then(() => {
        this.email.customer_id = null;
        this.unmatchLoading = false;
        this.$emit('onUnmatched', this.email);
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de e-mail niet ontkoppelen',
        });
      })
    },
    processBadges(badge, count) {
      let $badge = $(badge);
      if (count === 0) {
        $badge.addClass('hidden');
      } else {
        $badge.removeClass('hidden').text(count);
      }
    },
    onProcessClick() {
      this.processLoading = true;
    },
    onShowGroupedClick() {
      this.groupedOpened = !this.groupedOpened;
    },
    onMatchClick() {
      window.location.href = '/email/unmatched/' + this.email.id;
    },
    onEditClick(e) {
      this.editing = true;
    },
    onSave() {
      this.updateEmailName();
    },
    onCancel() {
      this.editing = false;
      this.$refs.emailNameInput.stateValue = this.email.name;
    },
    updateEmailName() {
      if (this.email.name === this.$refs.emailNameInput.stateValue) {
        this.editing = false;
        return;
      }

      this.email.name = this.$refs.emailNameInput.stateValue;
      this.updateNameLoading = true;

      emailApi.updateEmail(this.email.id, {
        name: this.email.name,
      }).then((response) => {
        this.editing = false;
        this.updateNameLoading = false;
      }).catch((error) => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de gewijzigde naam van de e-mail niet opslaan',
        });
      });
    },
    onSelectionChanged(e) {
      let shiftKey = false;

      if (typeof e.nativeEvent !== "undefined") {
        shiftKey = e.nativeEvent.shiftKey;
      }

      this.$emit('onSelectionChanged', this.afdMessage, !this.selected, shiftKey);
    },
  }
}
</script>

<style scoped>
tr td.half-padding {
  padding: 4px;
}

tr.selected {
  background-color: #1890ff1c;
}

table th.compact, table td.compact {
  white-space: nowrap;
  width: 1px !important;
}

tr .pencil-icon {
  display: none;
}

tr:hover .pencil-icon {
  display: initial;
}

.collapse-button .icon {
  transition: transform 300ms ease-in-out;
}

.table > tbody + tbody {
  border-top: 0;
}

.custom-collapse {
  display: none;
}

.custom-collapse.open {
  display: table-row;
}

.collapse-button.open .icon {
  transform: rotateZ(-180deg);
}
</style>
